import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ReportBuilderActionTypes } from './constants';
import { SagaIterator } from 'redux-saga';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import { APICore } from '../../helpers/api/apiCore';
import { changeReportChartsAction } from './actions';

const api = new APICore();


/**
 * Toggle the class on body
 * @param {*} cssClass
 */

/**
 * ---------------------------------------------------------------------------------------------------------------------------
 * Note: Following are the functions which allows you to save the user prefrences on backend side by making an api request.
 * For now, we are just applying the required logic on frontend side
 * ----------------------------------------------------------------------------------------------------------------------------
 */

const getChartListRequestAsync = async (item: any) => {
  try {
    let url: string = "";

    url = `${API_ENDPOINTS.GET_CHART_REPORTER}`;


    const { data } = await api.create(url, item);
    if (data.data)
      return data.data
    else {
      if (data.statusCode === 'UnAuthorized')
        return { "message": { title: 'UnAuthorized', message: '' } }
      else
        if (data.statusCode === 'ExpireTimeLink')
          return { "message": { title: 'ExpireTimeLink', message: data?.message } }
        else
          return data
    }
  }
  catch (e) {
    return { "message": e }
  };
}

function* getChartListItems({ payload }: any): SagaIterator {
  try {
    
      const response = yield call(getChartListRequestAsync, payload);
      yield put(changeReportChartsAction(response));
    
    //yield put(changeDashboardChartsAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}

export function* watchGetChartList(): any {
  yield takeEvery(ReportBuilderActionTypes.GET_CHARTLIST_REPORT, getChartListItems);
}


function* ReportBuilderSaga(): any {
    yield all([fork(watchGetChartList)]);
}

export default ReportBuilderSaga;
